/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../../../logger';

import type { ConceptXConfig } from '../../../types/vendor/conceptx';

const logger = Logger.getInstance();

declare global {
  interface Window {
    concept?: {
      targeting?: {
        contxt?: string[];
      };
    };
  }
}

class ConceptXFacts {
  static get(config: ConceptXConfig): string[] {
    if (config?.enabled !== false) {
      if (config?.classifiers && Array.isArray(config.classifiers)) {
        return config.classifiers.map(String);
      }

      const data = window?.concept?.targeting?.contxt;
      if (data && Array.isArray(data)) {
        logger.debug('ConceptX context data located in embedded global object');
        return data.map(String);
      }
    }
    return [];
  }
}

export { ConceptXFacts };
